export default __webpack_public_path__ + "static/media/arrowLeft-ios.8c3fdc92.svg";